export default {
    en: {
        pageTitle: "Using all components into a page"
    },
    es: {
        pageTitle: "Usar todos los componentes en una página"
    },
    ko: {
        pageTitle: "Sèvi ak tout eleman nan yon paj"
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/search-appointment/search-appointment.language.js
// module id = 636
// module chunks = 0